import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import http from "../services/httpService";
import AddRole from "./addRole";
import AddUser from "./addUser";
import RoleList from "./roleList";
import UserList from "./userList";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function UserManagementTabs() {
  const classes = useStyles();
  // let match = useRouteMatch();
  const [value, setValue] = React.useState(0);
  const [state, setState] = React.useState({});
  const [permitedTabsList, setPermitedTabsList] = React.useState([]);

  const changeAciveTab = (newValue) => {
    console.log(newValue, "rftgy");

    let index = 0;
    permitedTabsList.filter((object, inx) => {
      if (object.name === newValue) {
        console.log(newValue, "hi");
        index = inx;
        return { inx: inx };
      }
    });
    setValue(index);
  };
  const getState = (newValue) => {
    setState(newValue);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    http
      .get("/login_permissions")
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.Data &&
          Array.isArray(res.data.Data) &&
          res.data.Data.length > 0
        ) {
          let tabsList = [
            {
              name: "Roles",
              child: RoleList,
              props: { changeAciveTab: changeAciveTab, getState: getState },
            },

            {
              name: "Users",
              child: UserList,
              props: { changeAciveTab: changeAciveTab, getState: getState },
            },
            {
              name: "Add New Role",
              child: AddRole,
              props: { changeAciveTab: changeAciveTab, getState: getState },
            },
            {
              name: "Add New User",
              child: AddUser,
              props: { changeAciveTab: changeAciveTab, data: state },
            },
          ];
          let current_permission = res.data.Data.filter((obj) => {
            return obj.Mainmenu === "User Management";
          });
          if (current_permission && current_permission.length > 0) {
            if (
              current_permission[0]["Submenus"].indexOf("Add New Role") !== -1
            ) {
              current_permission[0]["Submenus"].push("Roles");
            }
            if (
              current_permission[0]["Submenus"].indexOf("Add New User") !== -1
            ) {
              current_permission[0]["Submenus"].push("Users");
            }
            let finalTabsList = tabsList.filter((object) => {
              if (
                current_permission[0]["Submenus"].indexOf(object.name) !== -1
              ) {
                return object;
              }
            });
            setPermitedTabsList(finalTabsList);
          }
        }
      })
      .catch((error) => {});
  }, []);

  return (
    <div className={(classes.root, "pb30")}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          indicatorColor="primary"
          textColor="primary"
          TabIndicatorProps={{ style: { display: "none" } }}
        >
          {permitedTabsList.map((text, index) => (
            <Tab
              label={text.name}
              key={index}
              {...a11yProps(index)}
              style={{ borderRadius: 20 }}
            />
          ))}
        </Tabs>
      </AppBar>
      {permitedTabsList.map((object, index) => {
        return (
          <TabPanel value={value} index={index} key={"tab" + index}>
            {React.createElement(object.child, object.props)}
          </TabPanel>
        );
      })}
    </div>
  );
}
export default UserManagementTabs;
